import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { HOTEL } from "@/data/hotel";

const today = () => new Date().toISOString().slice(0, 10);
const tomorrow = () => {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  return d.toISOString().slice(0, 10);
};

export const BookingWidget = ({ variant = "hero" }) => {
  const navigate = useNavigate();
  const [property, setProperty] = useState("hotel-azulo-inn");
  const [checkIn, setCheckIn] = useState(today());
  const [checkOut, setCheckOut] = useState(tomorrow());
  const [guests, setGuests] = useState(2);

  const onSubmit = (e) => {
    e.preventDefault();
    const params = new URLSearchParams({ property, check_in: checkIn, check_out: checkOut, guests });
    navigate(`/book?${params.toString()}`);
  };

  const isHero = variant === "hero";

  return (
    <form
      onSubmit={onSubmit}
      data-testid="booking-widget"
      className={
        isHero
          ? "backdrop-blur-md bg-ink-900/72 ring-1 ring-white/10 shadow-2xl shadow-ink-900/30 p-5 md:p-6 grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-3 items-end"
          : "bg-paper-50 border border-ink-900/10 p-6 md:p-8 grid grid-cols-1 md:grid-cols-12 gap-4 items-end"
      }
    >
      <div className="md:col-span-3">
        <label
          className={`block text-[10px] tracking-[0.22em] uppercase mb-2 ${isHero ? "text-paper-200" : "text-ink-500"}`}
        >
          Property
        </label>
        <select
          value={property}
          onChange={(e) => setProperty(e.target.value)}
          data-testid="bw-property"
          className={`w-full h-11 px-3 text-sm focus:outline-none ${
            isHero
              ? "bg-paper-50 text-ink-900"
              : "bg-paper-50 border border-ink-900/15 text-ink-900"
          }`}
        >
          <option value="hotel-azulo-inn">Hotel Azulo Inn — Safdarjung</option>
          <option value="hotel-ambica-palace" disabled>
            Hotel Ambica Palace (Coming soon)
          </option>
        </select>
      </div>
      <div className="md:col-span-3">
        <label
          className={`block text-[10px] tracking-[0.22em] uppercase mb-2 ${isHero ? "text-paper-200" : "text-ink-500"}`}
        >
          Check-in
        </label>
        <input
          type="date"
          value={checkIn}
          min={today()}
          onChange={(e) => setCheckIn(e.target.value)}
          data-testid="bw-checkin"
          className="w-full h-11 px-3 text-sm bg-paper-50 text-ink-900 focus:outline-none"
        />
      </div>
      <div className="md:col-span-3">
        <label
          className={`block text-[10px] tracking-[0.22em] uppercase mb-2 ${isHero ? "text-paper-200" : "text-ink-500"}`}
        >
          Check-out
        </label>
        <input
          type="date"
          value={checkOut}
          min={checkIn || today()}
          onChange={(e) => setCheckOut(e.target.value)}
          data-testid="bw-checkout"
          className="w-full h-11 px-3 text-sm bg-paper-50 text-ink-900 focus:outline-none"
        />
      </div>
      <div className="md:col-span-1">
        <label
          className={`block text-[10px] tracking-[0.22em] uppercase mb-2 ${isHero ? "text-paper-200" : "text-ink-500"}`}
        >
          Guests
        </label>
        <select
          value={guests}
          onChange={(e) => setGuests(Number(e.target.value))}
          data-testid="bw-guests"
          className="w-full h-11 px-3 text-sm bg-paper-50 text-ink-900 focus:outline-none"
        >
          {[1, 2].map((n) => (
            <option key={n} value={n}>
              {n}
            </option>
          ))}
        </select>
      </div>
      <div className="md:col-span-2">
        <button
          type="submit"
          data-testid="bw-submit"
          className="w-full h-11 bg-sage text-paper-50 text-[11px] tracking-[0.22em] uppercase hover:bg-sage-dark transition-colors"
        >
          Search Rooms
        </button>
      </div>
      {isHero && (
        <div data-testid="bw-manage-row" className="md:col-span-12 text-[11px] text-paper-200/80 tracking-wider md:-mt-1 pr-16 md:pr-0">
          Manage booking · <a href={`mailto:${HOTEL.email}`} className="underline">{HOTEL.email}</a>
        </div>
      )}
    </form>
  );
};

export default BookingWidget;
